// import { setUrlPath } from '@/lib';
import React from 'react';
import Modal from 'react-modal';
import Scrollbar from 'react-scrollbars-custom';

Modal.setAppElement('#root');

type Props = {
	modalStatus: boolean;
	closeModal: () => void;
};

const ModalRule: React.FC<Props> = ({ modalStatus, closeModal }) => {
	const afterOpenModal = () => { };

	const selfClose = (event: React.SyntheticEvent) => {
		event.preventDefault();
		const modalElement = document.querySelector('.swing-in-top-fwd');
		if (modalElement) {
			modalElement.classList.add('swing-out-top-bck');
		}
		// setUrlPath('/')

		setTimeout(() => {
			closeModal();
		}, 300);
	};

	return (
		<Modal
			isOpen={modalStatus}
			onAfterOpen={afterOpenModal}
			onRequestClose={selfClose}
			contentLabel="Example Modal"
			portalClassName="ReactModalPortal"
			overlayClassName=""
			className="swing-in-top-fwd modal-rule"
		>
			<div className="modal-description">
				<h2>Hướng dẫn</h2>
				<Scrollbar
					style={{ height: '26vw' }}
					className="modal-scrollbar"
					noScrollX={true}
				>
					<div className="rule">
						<h3>1. XÁC MINH SINH VIÊN</h3>
						<p>Để trải nghiệm được tốt nhất, HLV tham gia có thể chọn xác minh sinh viên theo 3 hình thức sau:</p>
						<p><strong>Xác thực qua mã OTP:</strong></p>
						<p>Đối tượng: HLV có email sinh viên (đuôi .edu).</p>
						<p>
							<ul>
								<li>Bước 1: Đăng nhập vào trang sự kiện, chọn xác minh sinh viên và điền đầy đủ thông tin theo mẫu.</li>
								<li>Bước 2: Chọn hình thức xác thực bằng email sinh viên.</li>
								<li>Bước 3: Chọn “nhận mã OTP”.</li>
								<li>Bước 4: Nhập mã OTP được gửi về email cá nhân để hoàn tất.</li>
							</ul>
						</p>
						<p>*HLV vui lòng kiểm tra hộp thư đến và thư rác (spam). OTP sẽ có hiệu lực trong vòng 24 tiếng kể từ khi yêu cầu lấy mã OTP. Trong thời gian chưa quá 2 tiếng, HLV vui lòng kiên nhẫn đợi mã OTP, không spam/gửi lại biểu mẫu nhiều lần để tránh nhầm lẫn mã OTP.</p>
						<br />
						<p><strong>Xác thực qua Microsoft Account hoặc Google Account:</strong></p>
						<p>Đối tượng: HLV có email sinh viên (đuôi .edu).</p>
						<p>
							<ul>
								<li>Bước 1: Đăng nhập vào trang sự kiện, chọn xác minh sinh viên và điền đầy đủ thông tin theo mẫu.</li>
								<li>Bước 2: Chọn hình thức xác thực bằng Microsoft Account hoặc Google Account và tiến hành xác nhận.</li>
							</ul>
						</p>
						<br />
						<p><strong>Xác thực qua mã QR (Tại Booth):</strong></p>
						<p>Đối tượng: HLV xác minh trực tiếp tại gian hàng sự kiện FC Online UniTour.</p>
						<p>
							<ul>
								<li>Bước 1: Đăng nhập vào trang sự kiện, chọn xác minh sinh viên và điền đầy đủ thông tin theo mẫu.</li>
								<li>Bước 2: Chọn hình thức xác thực bằng Mã QR.</li>
								<li>Bước 3: Xuất trình mã QR tại booth sự kiện để ban tổ chức quét trực tiếp.</li>
							</ul>
						</p>
						<p>Lưu ý quan trọng: các HLV không sử dụng, trao đổi email giả mạo/không chính chủ. Hệ thống sẽ tự động quét các trường hợp gian lận và tước quyền tham gia trang sự kiện.</p>
						<br />

						<h3>2. LỊCH TRÌNH FCO UNITOUR 2026</h3>
						<p>Theo dõi lịch trình FC Online UniTour ghé thăm 15 trường Đại học trên toàn quốc để tham gia các hoạt động offline và nhận quà trực tiếp.</p>
						<br />

						<h3>3. CHUYÊN CẦN TÍCH LŨY</h3>
						<p>Nhận ngay Phiếu giảm thuế 50%, gói UT, MDL,... (8~9), SPT & 26TOTS (+5)... Khi chăm chỉ hoàn thành nhiệm vụ.</p>
						<p>Hoàn thành các nhiệm vụ hằng ngày để tích lũy điểm chuyên cần. Điểm càng cao, mốc quà mở khóa càng giá trị.</p>
						<p>Lưu ý:</p>
						<p>
							<ul>
								<li>HLV cần Xác minh sinh viên thành công để mở khóa thêm kho quà đặc quyền.</li>
								<li>HLV cần chọn “nhận quà” sau khi tích lũy đủ điểm.</li>
							</ul>
						</p>
						<br />

						<h3>4. TỔ ĐỘI CÙNG TIẾN</h3>
						<p>Thành lập đội hình từ 3-5 thành viên để cùng cày nhiệm vụ và nhận thêm quà tích lũy. Gói cầu thủ CAP (+11), phiếu giảm thuế, cùng nhiều phần quà hấp dẫn khác đang chờ các tổ đội xuất sắc nhất.</p>
						<p>Điểm tích lũy của tổ đội là tổng điểm chuyên cần mà các thành viên thu thập được tại mục "Chuyên Cần Tích Lũy". HLV tham gia hoạt động này bằng cách:</p>
						<p><strong>Trường hợp 1: Tự tạo tổ đội mới</strong></p>
						<p>
							<ul>
								<li>Nhấn chọn "Tạo tổ đội mới" và xác nhận.</li>
								<li>HLV được mặc định trở thành đội trưởng của tổ đội đó và có quyền được kết nạp các thành viên khác bằng cách nhập mã.</li>
							</ul>
						</p>
						<p><strong>Trường hợp 2: Gia nhập tổ đội có sẵn</strong></p>
						<p>
							<ul>
								<li>Nhấn chọn "Tham gia tổ đội".</li>
								<li>Copy mã gia nhập của bạn và gửi cho đội trưởng tổ đội bạn muốn vào.</li>
								<li>Đội trưởng nhập mã mời và kết nạp thành công.</li>
							</ul>
						</p>
						<p>Lưu ý:</p>
						<p>
							<ul>
								<li>Chỉ có đội trưởng mới có thể kết nạp thành viên mới.</li>
								<li>Tổ đội phải có tối thiểu 3 thành viên để lập đội thành công và mở khóa quà tích lũy.</li>
								<li>Mỗi HLV chỉ được có mặt trong 1 tổ đội.</li>
								<li>Sau khi gia nhập thành công, HLV không thể rời đội hoặc xóa thành viên trong suốt thời gian diễn ra sự kiện.</li>
							</ul>
						</p>
						<br />

						<h3>5. TIẾP SỨC TỰU TRƯỜNG</h3>
						<p>Shop ưu đãi mở bán các gói vật phẩm đặc biệt nhân dịp Tựu Trường 2026:</p>
						<p>Dành cho HLV đã xác minh sinh viên:</p>
						<p>
							<ul>
								<li>Giảm giá 50% khi mua Sổ Tay đặc biệt Back To School.</li>
								<li>Giảm giá 50% cho tối đa 2 gói Monthly bất kỳ tháng 8.</li>
							</ul>
						</p>
						<br />

						<h3>6. BẢNG VÀNG VINH DANH</h3>
						<p>Rủ bạn cùng trường đăng nhập tham gia sự kiện để đưa trường mình lên vị trí cao trên Bảng xếp hạng.</p>
						<p>Top 50 trường có nhiều sinh viên tham gia trang sự kiện sẽ nhận được thẻ cầu thủ +8 cùng nhiều phần quà giá trị khác khi kết thúc.</p>
						<p>Đặc biệt: top 10 BXH mỗi tuần sẽ được nhận thêm 1 lượt quay tại vòng quay may mắn.</p>
						<br />

						<h3>7. CHÀO BẠN MỚI, ĐÓN BẠN CŨ</h3>
						<p>Hoạt động tặng quà tiếp sức dành riêng cho HLV mới và HLV quay trở lại sân cỏ. Hoàn thành các nhiệm vụ để nhận ngay combo vật phẩm giá trị.</p>
						<p>Điều kiện áp dụng:</p>
						<p>
							<ul>
								<li>HLV trở lại: Tài khoản không có lịch sử đăng nhập game từ ngày 01.08.2026 đến hết ngày 03.09.2026.</li>
								<li>HLV mới: Tài khoản được tạo từ ngày 04.09.2026 trở đi.</li>
							</ul>
						</p>
						<br />

						<h3>7. VÒNG QUAY MAY MẮN</h3>
						<p>Tham gia vòng quay may mắn để có cơ hội săn 10.000 FC quà tặng giá trị.</p>
						<p>Các HLV nhận lượt quay thông qua:</p>
						<p>
							<ul>
								<li>Nhận 1 lượt quay ngay khi xác minh sinh viên thành công.</li>
								<li>Nhận thêm 1 lượt quay/tuần nếu trường ĐH của HLV nằm trong top 10 trường có số lượng sinh viên tham gia sự kiện đông nhất.</li>
								<li>Nhận tối đa thêm 4 lượt quay khi hoàn thành các mốc quà tại hoạt động "Chuyên Cần Tích Lũy".</li>
							</ul>
						</p>
						<br />
						<p><strong>Chúc các HLV rinh được những phần quà giá trị và đón năm học mới bùng nổ!</strong></p>
					</div>
				</Scrollbar>
			</div>
			<a onClick={event => selfClose(event)} className="close" data-dismiss="modal" aria-label="Close">
				×
			</a>
		</Modal>
	);
};
export default ModalRule;
